import { type FormField } from "@/feature/ewbci";
import { validateType } from "./validateForm";

export const HistoryType = {
    Pending: '送信待ち',
    Sending: '送信中',
    Send: '送信', // 送信(完了)
    Receive: '受信', // 受信
    Ignored: '受信(無視)', // 受信
    Conflicted: '競合',
    Resolved: '解決',
    Canceled: 'キャンセル',
} as const;// TODO: Send, Receive, Conflicted, Resolved, Ignored以外は未実装
export type HistoryType = (typeof HistoryType)[keyof typeof HistoryType];

export type HistoryItem = {
    type: HistoryType; // 履歴タイプ
    fieldName: string; // フォームフィールドのキー
    prev?: string; // 更新前の値
    next: string; // 更新後の値
    timestamp?: Date; // タイムスタンプ
    tag?: string; // 検索用のキー
};

export const DraftStatus = {
    None: 'データなし',
    Idle: '未編集',
    Updated: '更新あり',
    Editing: '編集中',
    Dirty: '送信待ち',
    Sending: '送信中',
    Conflict: '競合',
} as const;
export type DraftStatus = typeof DraftStatus[keyof typeof DraftStatus];

export type PendingRequest = {
    value: string;
    timestamp: Date;
}

export type Draft = {
    key: string;
    status: DraftStatus;
    local?: string;
    remote?: string;
    updatedAt?: Date;
    pending?: PendingRequest[];
    errorAt?: number; // 直近のエラー発生時刻(UNIXTIME)
};

export type DraftMap = { [key: string]: Draft };

export type FormFieldDef = FormField & {
    readonly?: boolean;
    validateType: validateType;
};